<form [formGroup]="form" (ngSubmit)="$event.preventDefault()">
  <div class="row no-gutters">

    <div class="col min-width-230">
      <rask-selector
        label="Handelssortimentsgrupp"
        [required]="true"
        class="w-100"
        formControlName="handelssortimentsgruppId" [values]="handelssortimentgruppList"
        [viewFormatter]="handelssortimentsgruppFormatter" [formatter]="handelssortimentsgruppOutputFormatter"
        [rule]="validationContext.current.handelssortimentGrupp" aid="inputHandelssortimentsgrupp">
      </rask-selector>
    </div>

    <div class="col-auto custom-width-90">
      <rask-textmultiline aid="inputEnhetUppfoljning" label="Lagerenhet" [value]="handelssortiment.lagerenhet">
      </rask-textmultiline>
    </div>

    <div class="col custom-width-320">
      <rask-datepicker
        aid="inputFrom"
        class="date-with-day"
        [required]="true"
        label="Giltig fr.o.m."
        formControlName="giltigFrom"
        [rule]="validationContext.current.giltligFrom">
      </rask-datepicker>
      <rask-datepicker
        aid="inputTom"
        class="date-with-day float-end"
        [minDate]="form.controls.giltigFrom.value"
        formControlName="giltigTom"
        label="Giltig t.o.m.">
      </rask-datepicker>
    </div>

    <div class="col">
      <rask-selector
        [required]="true"
        [canDelete]="false"
        label="Föreslaget måttslag"
        class="custom-width-150"
        formControlName="foreslagetMattslag"
        [values]="foreslagnamattslagList"
        [reverseLookup]="false">
      </rask-selector>
    </div>

    <div class="col min-width-275">
      <rask-input-number
        class="custom-width-90"
        label="Densitet"
        formControlName="densitetSkotning"
        [min]="1"
        [rule]="validationContext.current.densitetSkotning">
      </rask-input-number>
      <rask-textmultiline label="Leveransinstruktion" class="custom-button float-end" infoText="FDI-fil">
        <rask-button type="button" color="secondary" icon="fal fa-download" (click)="downloadFDI(false)" [disabled]="isNew()">Viol2</rask-button>
         <rask-button type="button" class="d-block" color="secondary" icon="fal fa-download" (click)="downloadFDI(true)" [disabled]="isNew() || !handelssortiment.viol3HandelssortimentInfo?.identitet || !handelssortiment.forProduktion">Viol3</rask-button>
      </rask-textmultiline>
    </div>
  </div>

  <div class="row no-gutters">
    <div class="col min-width-230" ng-init="filterNonSelected = ''">
      <div class="custom-sortiment">
        <label for="inputNonSelected" class="col-form-label">Samtliga sortimentskoder</label>
        @if (initialized) {
          <rask-filter-list
            aid="inputNonSelected"
            [items]="sortimentList"
            [ngModelOptions]="{standalone: true}"
            [disabled]="form.disabled"
            [exclude]="selectedSortiment"
            [(ngModel)]="allSortimentSelection"
            [formatter]="viewSortimentFormatter"
            excludeFilterProperty="id">
          </rask-filter-list>
        }
      </div>
    </div>

    <div class="col-auto mt-5 custom-width-90">
      <div class="row">
        <div class="col-12 text-center">
          <button type="button" id="buttonAddSortimentskod" (click)="addSortiment()"
            [disabled]="form.disabled"
            class="btn btn-tertiary mb-1 str mx-auto align-content-center" data-type="str">
            <span class="far fa-chevron-right"></span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button type="button" id="buttonRemoveSortimentskod" (click)="removeSortiment()"
            [disabled]="form.disabled"
            class="btn btn-tertiary stl mx-auto" data-type="stl">
            <span class="far fa-chevron-left"></span>
          </button>
        </div>
      </div>
    </div>

    <div class="col custom-width-320">
      <div class="custom-sortiment">
        <label for="inputSelected" class="col-form-label">Valda sortimentskoder</label>
        @if (initialized) {
          <rask-filter-list [items]="selectedSortiment" [ngModelOptions]="{standalone: true}"
            [(ngModel)]="choosenSortimentSelection" [formatter]="viewSortimentFormatter" aid="inputSelected" [disabled]="form.disabled">
          </rask-filter-list>
        }
      </div>
    </div>

    <div class="col">
      @if (initialized) {
        <rask-selector
          aid="inputHuvudsortiment"
          label="Huvudsortiment"
          class="w-100"
          [disabled]="form.disabled"
          [canDelete]="true"
          [formatter]="sortimentFormatter"
          [viewFormatter]="viewSortimentFormatter"
          [rule]="validationContext.current.huvudsortiment"
          [ngModel]="handelssortimentSortiment.huvudsortimentId"
          (ngModelChange)="changeHuvudSortiment($event)"
          [ngModelOptions]="{standalone: true}"
          [values]="selectedSortiment">
        </rask-selector>
      }

      @if (ravaruHandelssortiment) {
        <rask-textmultiline aid="ravaruHandelssortiment" label="Råvara från">
          <a [routerLink]="['/handelssortiment', ravaruHandelssortiment.id]">{{ ravaruHandelssortiment.namn }}</a>
        </rask-textmultiline>
      }

      @if (foradlingsHandelssortiment?.length) {
        <rask-textmultiline aid="foradlingsHandelssortiment" label="Förädlad form">
          @for (fh of foradlingsHandelssortiment; track fh) {
            <div>
              <a [routerLink]="['/handelssortiment', fh.id]">{{ fh.namn }}</a>
            </div>
          }
        </rask-textmultiline>
      }
    </div>

    <div class="col min-width-275">
      <rask-textarea aid="inputBeskrivning" label="Beskrivning" class="w-100" [rows]="8" [maxlength]="1000"
      formControlName="beskrivning"></rask-textarea>
    </div>
  </div>
</form>
